export default function($) {

  function client_autocomplete($) {
    var autocomplete_client_input = $('#js-client-autocomplete-input');

    if (!autocomplete_client_input.length) {
      return
    }

    var client_labels = autocomplete_client_input.data('labels')
    var client_values = autocomplete_client_input.data('values')

    var source_mapping = $.map( client_labels, function( label, i ) {
      return { label: label, value: client_values[i] };
    });

    autocomplete_client_input.autocomplete({
      minLength: 2,
      source: source_mapping,
      select: function( event, ui ) {
        event.preventDefault();

        var redirect_url = ui.item.value
        var label = ui.item.label

        autocomplete_client_input.val(label)

        window.location = redirect_url
      },
      focus: function( event, ui ) {
        return false
      },
    })
  }

  function client_autocomplete_no_redirect($) {
    var autocomplete_client_input = $('#js-customer-autocomplete-no-redirect-input');

    if (!autocomplete_client_input.length) {
      return
    }

    var client_labels = autocomplete_client_input.data('labels')
    var client_values = autocomplete_client_input.data('values')

    var source_mapping = $.map( client_labels, function( label, i ) {
      return { label: label, value: client_values[i] };
    });

    autocomplete_client_input.autocomplete({
      minLength: 2,
      source: source_mapping,
      select: function( event, ui ) {
        event.preventDefault();

        var value = ui.item.value
        var label = ui.item.label

        autocomplete_client_input.val(label)
        $('#customer_id').val(value)
      },
      focus: function( event, ui ) {
        return false
      },
    })
  }

  function wished_expedition_datepicker($) {
    var wished_expedition_date = $('#js-client-wished-expedition-date');

    if (!wished_expedition_date.length) {
      return
    }

    wished_expedition_date.datepicker({
      dateFormat: "dd/mm/yy",
      minDate: $.datepicker.formatDate('dd/mm/yy', new Date()),
    });

    // Minimalist date validation before submit
    wished_expedition_date.change(function(event) {
      wished_expedition_date_remove_displayed_error()

      var date_value = wished_expedition_date.val()
      if (validate_wished_expedition_date(date_value)) {
        return;
      }

      wished_expedition_date_display_error()
    })

    // Minimalist date validation on submit
    $('#place_order').click(function(event) {
      wished_expedition_date_remove_displayed_error()

      var date_value = wished_expedition_date.val()
      if (validate_wished_expedition_date(date_value)) {
        return;
      }

      event.preventDefault()
      wished_expedition_date_display_error()
    });
  }

  function wished_expedition_date_remove_displayed_error() {
    var wished_expedition_date = $('#js-client-wished-expedition-date')

    wished_expedition_date.removeClass('iw-validation-error')
    $('#js-client-wished-expedition-date-validation-error').remove()
  }

  function wished_expedition_date_display_error() {
    var wished_expedition_date = $('#js-client-wished-expedition-date')

    wished_expedition_date.addClass('iw-validation-error')
    if ( !$('.js-client-wished-expedition-date-validation-error').length ) {
      wished_expedition_date.after('<span id="js-client-wished-expedition-date-validation-error">&nbsp;&nbsp;Date invalide, merci d\'utiliser le sélecteur ou de respecter le format jj/mm/aaaa</span>')
    }
    wished_expedition_date.focus()
  }

  function validate_wished_expedition_date(date) {
    if (!date.length) {

      return true;
    }
    return date.match(/^\d\d?\/\d\d?\/\d\d\d\d$/) !== null
  }

  client_autocomplete($);
  client_autocomplete_no_redirect($);
  wished_expedition_datepicker($);

}
